import { createFileRoute, Outlet } from '@tanstack/react-router';

import { NavigationSidebarSupplier } from '@/areas/suppliers/Suppliers/NavigationSidebarSupplier';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the Suppliers sidebar; the details page and the importers stay outside this group.
export const Route = createFileRoute('/_authenticated/suppliers/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<NavigationSidebarSupplier />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
